/**********************
 *
 */

import React, { useState } from "react";
import { sendGET } from "../utils/comm.js";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSync, faQuestion } from "@fortawesome/free-solid-svg-icons";
//import ReactTooltip from "react-tooltip";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const AddRow = ({
  list,
  shouldHighlight,
  shouldColor,
  callback,
  questions,
}) => {
  const [showDialog, setShowDialog] = useState(false);
  const [showQuestions, setShowQuestions] = useState(false);
  const [newUser, setNewUser] = useState(list[2]);
  console.log(
    "addRow: Heres the list:",
    list,
    "and here are the questions:",
    questions
  );
  return (
    <div
      style={{
        display: "table-row",
        whiteSpace: "nowrap",
        lineHeight: "1.7em",
        fontWeight: shouldHighlight ? "bold" : "normal",
        backgroundColor: shouldColor ? "#e0f4e9" : "normal",
        fontSize: "1.6em",
      }}
    >
      <Dialog
        open={showQuestions}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => callback("cancel")}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">
          {"Questions answered by " + list[2]}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {questions &&
              questions.map((q, idx) => {
                //console.log("Looking at q:", q);
                let color = "black";
                if (q.selection >= 2) color = "rgb(255,200,0)";
                if (q.selection >= 4) color = "red";
                if (q.isMetadata) return null;
                return (
                  <div style={{ color: color }}>
                    #{idx}&nbsp;
                    {q.question} ({q.selection})
                  </div>
                );
              })}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              console.log("Cancel called...");
              setShowQuestions(false);
              //              callback();
            }}
            color="primary"
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={showDialog}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => callback("cancel")}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">
          {"Resend this survey's PDF to the email below?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            You may change this email address; it is not saved in the database.
          </DialogContentText>
          <label>Send-to this address:&nbsp;</label>
          <input
            value={newUser}
            size={45}
            onChange={(e) => {
              e.preventDefault();
              setNewUser(e.target.value);
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              console.log("Cancel called...");
              setShowDialog(false);
              callback();
            }}
            color="primary"
          >
            Cancel
          </Button>
          <Button
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              console.log("Invoking resend...");
              setShowDialog(false);
              callback(newUser);
            }}
            color="primary"
          >
            Resend
          </Button>
        </DialogActions>
      </Dialog>
      {shouldHighlight ? (
        <div style={{ marginRight: "10px", width: "25px" }} />
      ) : (
        <>
          <span
            data-tip="Resend PDF report..."
            style={{ marginRight: "10px", width: "25px" }}
            onClick={(e) => {
              let [date, dateValue, userEmail] = list;
              e.preventDefault();
              e.stopPropagation();
              console.log("Click, e:", e, "list:", list, date);
              console.log("dateValue:", dateValue, "userEmail:", userEmail);
              setShowDialog(true);
            }}
          >
            <span className="tooltip">
              <FontAwesomeIcon icon={faSync} />
              <span className="tooltiptext">
                Re-send PDF to possibly new email address...
              </span>
            </span>
          </span>
          <span
            data-tip="Let's see how the patient responded to the questions"
            style={{ marginRight: "10px", width: "25px" }}
            onClick={(e) => {
              let [date, dateValue, userEmail] = list;
              e.preventDefault();
              e.stopPropagation();
              console.log("Click, e:", e, "list:", list, date);
              console.log("dateValue:", dateValue, "userEmail:", userEmail);
              setShowQuestions(true);
            }}
          >
            <span className="tooltip">
              <FontAwesomeIcon icon={faQuestion} />
              <span className="tooltiptext">
                Lets see how the patient answered the questions
              </span>
            </span>
          </span>
        </>
      )}
      {list.map((item, idx) => {
        let style = { display: "table-cell", paddingRight: "16px" };
        if (idx === 0 || idx === 1) {
          // Date and Invoice columns
          // Date field; mono-space
          style = { ...style, fontFamily: "Courier New" };
        }
        if (idx === 5 && item !== "Paid") {
          // pennies paid
          if (item !== undefined) {
            item = "$" + (parseInt(item) / 100).toFixed(2);
            style = { ...style, textAlign: "right", fontFamily: "Courier New" };
          }
        }
        return (
          <div style={style} key={idx}>
            {item}
          </div>
        );
      })}
    </div>
  );
};

const handleOldFormat = (results) => {
  let top5 = results.analyzedResults.sortedDiseasesArray.slice(0, 5);
  let line = "";
  top5.map((diag, idx) => {
    let result = diag.diag + "(" + diag.percent + ")";
    if (idx < top5.length - 1) result += ", ";
    return (line += result);
  });
  line += " Health Idx: " + results.analyzedResults.index.toFixed(2) + " ";
  return <span>{line}</span>;
};

const resultsText = (results) => {
  // WARNING: If this report is before 3/22/2021 it is in old format and needs
  // to be handled differently. Check that first...
  if (results.analyzedResults.sortedDiseasesArray)
    return handleOldFormat(results);

  let top5 = results.analyzedResults.sortedRootCausesArray.slice(0, 5);
  let line = "";
  let line2 = "";

  top5.map((rootCause, idx) => {
    let result = rootCause.rootCause + "(" + rootCause.percent + ")";
    if (idx < top5.length - 1) result += ", ";
    return (line += result);
  });

  line += " Health Idx: " + results.analyzedResults.index.toFixed(2) + " ";
  if (results.analyzedResults.sortedWeightedRootCausesArray) {
    top5 = results.analyzedResults.sortedWeightedRootCausesArray.slice(0, 5);
    top5.map((rootCause, idx) => {
      let result =
        rootCause.rootCause + "(" + rootCause.percent.toFixed(0) + ")";
      if (idx < top5.length - 1) result += ", ";
      return (line2 += result);
    });

    return (
      <div>
        <span>
          <b>Scores:</b>
        </span>
        <span style={{ marginLeft: "25px" }}>{line}</span>
        <div>
          <span>
            <b>Weighted:</b> {line2}
          </span>
        </div>
        {results.analyzedResults.allCalculations &&
          ShowAllCalculations(results)}
        <div>{JSON.stringify(results.demographics)}</div>
      </div>
    );
  } else return <span>{line}</span>;
};

const ShowAllCalculations = (results) => {
  let allCalculations = results.analyzedResults.allCalculations;
  return (
    <>
      {allCalculations.map((calculationObject) => {
        if (calculationObject.type === "weightings") return null; // We already show this one
        if (
          calculationObject.type !== results.demographics?.concern &&
          calculationObject.type !== results.promo
        )
          return null;
        return (
          <div>
            <b>{calculationObject.type}:</b>{" "}
            {calculationObject.calculation.slice(0, 5).map((calculation) => {
              return (
                <span>
                  <span style={{ color: "blue", fontWeight: "bold" }}>
                    {calculation.rootCause}
                  </span>
                  ({calculation.percent.toFixed(0)}) ,&nbsp;
                </span>
              );
            })}
          </div>
        );
      })}
    </>
  );
};

export default (props) => {
  const [fromDate, setFromDate] = useState(3);
  const [userEmail, setUserEmail] = useState();
  let [rows, setRows] = useState(<div></div>);
  const [code, setCode] = useState("");
  const [progressItems, setProgressItems] = useState([]);
  const [shortened, setShortened] = useState(false);
  const [emailListsOnly, setEmailListsOnly] = useState(false);
  const [concerns, setConcerns] = useState({});
  const [otherConcerns, setOtherConcerns] = useState([]);
  const [concernInfo, setConcernInfo] = useState([]);

  /*
  function uncompletedSurveys() {
    // Look at each 'userEmail' in the progressItems array
    // Then look at paidFree, paidFull, and if not found in either, then include that user in the response
    let result = [];
    for (
      let progressIdx = 0;
      progressIdx < progressItems.length;
      progressIdx++
    ) {
      console.log(
        "uncompleteSurveys looking for user:",
        progressItems[progressIdx].userEmail
      );
      if (
        paidFree.find((item) => item === progressItems[progressIdx].userEmail)
      )
        continue;
      if (
        paidFull.find((item) => item === progressItems[progressIdx].userEmail)
      )
        continue;
      if (
        paidUndefined.find(
          (item) => item === progressItems[progressIdx].userEmail
        )
      )
        continue;
      console.log(
        "uncompleteSurveys: adding user:",
        progressItems[progressIdx].userEmail
      );
      if (result.find((item) => item == progressItems[progressIdx].userEmail))
        continue;
      result.push(progressItems[progressIdx].userEmail);
    }
    return result.join(",");
  }
  */

  return (
    <div
      style={{
        color: "black",
        backgroundColor: "rgb(244,245,250)",
        borderRadius: "30px",
        margin: "auto auto",
        marginTop: "10px",
        padding: "1em",
        // width: "90%",
        display: "inline-block",
        fontSize: "1em",
      }}
    >
      <h2>Report Generation</h2>
      <label>Code:&nbsp;</label>
      <input
        type="text"
        value={code}
        onChange={(e) => {
          e.preventDefault();
          setCode(e.target.value);
        }}
      />
      <label>&nbsp;From how many days past:&nbsp;</label>
      <input
        type="text"
        value={fromDate}
        size={4}
        onChange={(e) => {
          e.preventDefault();
          setFromDate(e.target.value);
        }}
      />
      <label>&nbsp;OR the user email:&nbsp;</label>
      <input
        type="text"
        value={userEmail}
        size={40}
        onChange={(e) => {
          e.preventDefault();
          setUserEmail(e.target.value);
        }}
      />
      &nbsp;
      <button
        onClick={async (e) => {
          e.preventDefault();
          e.stopPropagation();

          let str;
          if (userEmail) {
            str = "/resultbyemail/" + userEmail + "/" + code;
          } else {
            console.log(
              "Cur getTime:",
              new Date().getTime(),
              "fromDate:",
              fromDate
            );
            console.log(
              "after subtraction:",
              new Date(new Date().getTime() - 24 * 60 * 60 * 1000 * fromDate)
            );
            let ddd = new Date(
              new Date().getTime() - 24 * 60 * 60 * 1000 * fromDate
            );
            if (emailListsOnly)
              str = "/emailListsSince/" + code + "/" + ddd.getTime();
            else str = "/since/" + code + "/" + ddd.getTime();

            // Build-up the 'progress' array so we can find out who skipped out early
            let progressCommand = "/progress/" + code + "/" + ddd.getTime();
            let progressItems = await sendGET(progressCommand);
            // Now just keep the "event='Email accepted'" items
            progressItems = progressItems.filter(
              (item) => item.event === "Email accepted"
            );
            setProgressItems(progressItems);
          }

          let results = await sendGET(str);
          console.log("results:", results);
          if (emailListsOnly) {
            setRows(
              <div>
                <div>
                  <b>Paid:</b> {results.paidFull}
                </div>
                <div>
                  <b>Free:</b> {results.free}
                </div>
                <div>
                  <b>Unpaid:</b> {results.unpaid}
                </div>
              </div>
            );
          } else {
            rows = [];
            rows.push(
              <AddRow
                list={[
                  "Date",
                  "Invoice",
                  "Email",
                  "Gender",
                  "Age",
                  "Paid",
                  "Promo",
                  "Results",
                ]}
                shouldHighlight={true}
                shouldColor={false}
                callback={(e) => {}}
              />
            );
            let tempConcerns = {};
            let tempConcernInfo = [];
            let tempOtherConcerns = [];

            for (let i = 0; i < results.length; i++) {
              if (shortened) {
                if (
                  !results[i].demographics ||
                  !results[i].demographics.concern
                )
                  continue;
                if (results[i].demographics.concern.indexOf("Other") > -1) {
                  tempOtherConcerns.push(results[i].demographics.concerninfo);
                }
                if (results[i].demographics.extrainfo) {
                  tempOtherConcerns.push(
                    "Extra-info: " + results[i].demographics.extrainfo
                  );
                }
                rows.push(
                  <AddRow
                    list={[
                      results[i].clientDateLocale
                        .replace(/ /g, "")
                        .replace(",", "-"),
                      results[i].dateValue,
                      results[i].userEmail,
                      results[i].gender || results[i].demographics?.gender,
                      results[i].age || results[i].demographics?.age,
                      results[i].penniesPaid,
                      results[i].promo,
                      <div>
                        <b>Concern:</b> {results[i].demographics.concern}{" "}
                        <b>Concern Info:</b>
                        {results[i].demographics.concerninfo} <b>Extra Info:</b>
                        {results[i].demographics.extrainfo}
                      </div>,
                    ]}
                  />
                );
                if (results[i].demographics.concerninfo)
                  tempConcernInfo.push(results[i].demographics.concerninfo);
                tempConcerns[results[i].demographics.concern] = tempConcerns[
                  results[i].demographics.concern
                ]
                  ? tempConcerns[results[i].demographics.concern] + 1
                  : 1;
              } else
                rows.push(
                  <AddRow
                    list={[
                      results[i].clientDateLocale
                        .replace(/ /g, "")
                        .replace(",", "-"),
                      results[i].dateValue,
                      results[i].userEmail,
                      results[i].gender || results[i].demographics?.gender,
                      results[i].age || results[i].demographics?.age,
                      results[i].penniesPaid,
                      results[i].promo,
                      resultsText(results[i]),
                    ]}
                    questions={results[i].questions}
                    shouldHighlight={false}
                    shouldColor={i % 2 === 0}
                    callback={async (userEmail) => {
                      console.log("Callback called, userEmail:", userEmail);
                      if (userEmail) {
                        console.log("Sending command to server...");
                        try {
                          let result = await sendGET(
                            "/emailpdf/" +
                              results[i].dateValue +
                              "/" +
                              userEmail
                          );
                          //console.log("Result:", result);
                        } catch (e) {
                          console.log("Failed emailpdf:", e);
                        }
                      }
                    }}
                  />
                );
            }
            if (shortened) {
              setConcerns(tempConcerns);
              setOtherConcerns(tempOtherConcerns);
              setConcernInfo(tempConcernInfo);
            }

            setRows(
              <div
                style={{
                  display: "table",
                  fontSize: "0.5em",
                  marginTop: "10px",
                }}
              >
                {rows}
              </div>
            );
          }
        }}
      >
        {" "}
        GO
      </button>
      <input
        type="checkbox"
        id="shortened"
        name="shortened"
        checked={shortened}
        onChange={(e) => {
          setShortened((oldValue) => !oldValue);
        }}
      />
      <label for="shortened"> Shortened</label>
      <input
        type="checkbox"
        id="emailListsOnly"
        name="emailListsOnly"
        checked={emailListsOnly}
        onChange={(e) => {
          setEmailListsOnly((oldValue) => !oldValue);
        }}
      />
      <label for="emailListsOnly">Show emailListsOnly</label>
      <br />
      {rows}
      {shortened && Object.keys(concerns).length !== 0 ? (
        <>
          <div style={{ fontSize: "1.1em" }}>
            <b>Summary of conditions:</b>&nbsp;&nbsp;
            {Object.keys(concerns).map((key) => (
              <span>
                {key}: <b>{concerns[key]}</b>&nbsp;&nbsp;
              </span>
            ))}
          </div>

          <b style={{ marginTop: "10px" }}>
            List of mentioned 'other' concerns:
          </b>
          <ul>
            {otherConcerns.map((other) => (
              <li>{other}</li>
            ))}
          </ul>

          <b style={{ marginTop: "10px" }}>List of mentioned 'concern info':</b>
          <ul>
            {concernInfo.map((concern) => (
              <li>{concern}</li>
            ))}
          </ul>
        </>
      ) : null}
    </div>
  );
};
